import React from "react";
import { motion } from "framer-motion";
import { CheckCircle } from "lucide-react";
import { useLanguage } from "@/context/LanguageContext";
import { commonLabels } from "@/i18n";

const SecurityGuarantee = () => {
  const { language } = useLanguage();
  const labels = commonLabels(language);
  const guaranteeData =
    labels.menuPages?.howItWorks?.securitySection?.guarantee || {};

  return (
    <motion.div
      initial={{ opacity: 0, y: 50 }}
      whileInView={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.8 }}
      viewport={{ once: true }}
      className="text-center"
    >
      <div className="bg-gradient-to-r from-blue-600/20 to-purple-600/20 backdrop-blur-xl rounded-2xl md:rounded-3xl p-8 md:p-12 border border-white/10 max-w-4xl mx-auto">
        <h3 className="text-2xl md:text-3xl font-bold text-white mb-4 md:mb-6">
          {guaranteeData.title || "100% Säkerhetsgaranti"}
        </h3>
        <p className="text-base md:text-xl text-gray-300 mb-6 md:mb-8 leading-relaxed">
          {guaranteeData.description ||
            "Om något går fel ersätter vi din förlust. Det är vårt löfte till dig som kund."}
        </p>
        <div className="flex flex-wrap justify-center gap-4 md:gap-6 text-xs md:text-sm">
          {(guaranteeData.features || []).map(
            (feature: string, index: number) => (
              <div key={index} className="flex items-center text-gray-300">
                <CheckCircle className="w-4 h-4 md:w-5 md:h-5 text-green-400 mr-2" />
                <span>{feature}</span>
              </div>
            ),
          )}
        </div>
      </div>
    </motion.div>
  );
};

export default SecurityGuarantee;
